export default __webpack_public_path__ + "images/0x479673391b3818f5e3ed2fa69a58e13d685becf6.png";